/* eslint-disable no-undef, angular/document-service, angular/window-service */
var production = (process.env.NODE_ENV === 'production'),
    revision = document.getElementsByTagName('script')[0].src.match('[?]rev=([0-9.]+)')[1],
    server;
if (window.serverEndpoint) // when defined in config.js, use it
    server = window.serverEndpoint;
else if (!production)
    server = 'https://tomcat9.andxor.it/tinv.approve/';
else
    server = ''; // relative path
/* eslint-enable */

// CSS resources
import 'bootstrap/dist/css/bootstrap.css';
import 'highlight.js/styles/default.css';
import 'client.css';

// JavaScript resources
import cfg from '../src/config.json';
import angular from 'angular';
import 'angular-ui-bootstrap';
import X2JS from '@andxor/x2js';
import 'controller/login';
import 'controller/lista';
import 'controller/form';
import 'directive/misc';
import 'directive/files';
import 'directive/xmltree';

//TODO: remove after https://github.com/Gillespie59/eslint-plugin-angular/issues/549
// eslint-disable-next-line angular/function-type
angular.module('Invoice', [
    'ui.bootstrap',
    'TInv.ctrl.Login',
    'TInv.ctrl.Lista',
    'TInv.ctrl.Form',
    'TInv.dir',
    'TInv.dir.files',
    'TInv.dir.xmltree',
]).constant('server', server
).constant('tinv', cfg.server.replace(/[/]$/, '')
).constant('revision', revision
).factory('x2js', function () {
    // https://stackoverflow.com/questions/19420604/angularjs-stack-trace-ignoring-source-map
    return new X2JS();
});

angular.bootstrap(document, ['Invoice'], {
    strictDi: production
});
